import { API_PATHS } from "../../paths";
import axios from "axios";
import Resume from "../../Model/ResumeModel";
import { flashMessage } from "../../../utils/flashMessageService";

export async function ResumeCardData() {
  try {
    const token = localStorage.getItem('authToken');
    const response = await axios.get(

      API_PATHS.resumes,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      }
    );
    // Format the data using the Resume model
    const formattedData = response.data.resumes.map(resume => new Resume(
      resume._id,
      resume.resumeId,
      resume.name,
      resume.videoURL,
      resume.pdfURL,
      resume.description,
      resume.skills,
      resume.category,
      resume.transport,
      resume.location,
      resume.industry,
      resume.isFavorite
    ));

    return formattedData;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response && error.response.status === 400) {
      console.error("get  resume failed with status 400:", error.response.data);
      flashMessage(`Get resume failed: ${error.response.data.error}`, { type: "error" });
    } else {
      console.error("Error getting resume:", error);
      flashMessage("Get resume failed. Please try again.", { type: "error" });
    }
    console.error(`Error getting resume with id `, error);
    throw error;
  }
}

export async function deleteResume(id) {
  try {
    const token = localStorage.getItem('authToken');
    await axios.delete(`${API_PATHS.resumes}/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`, // Add the Authorization header
      },
    });
  } catch (error) {
    if (axios.isAxiosError(error) && error.response && error.response.status === 400) {
      console.error("delete resume failed with status 400:", error.response.data);
      flashMessage(`Delete resume failed: ${error.response.data.error}`, { type: "error" });
    } else {
      console.error("Error deleting resume:", error);
      flashMessage("Delete resume failed. Please try again.", { type: "error" });
    }
    console.error(`Error deleting resume with id ${id}:`, error);
    throw error;
  }
}

export async function updateResumeAPI(updatedResume) {
  try {
     const updateFormData = new FormData();
                updateFormData.append('name', updatedResume.name);
                // only append files if provided
                if (updatedResume.video) updateFormData.append('video', updatedResume.video);
                if (updatedResume.pdf) updateFormData.append('pdf', updatedResume.pdf);
                // skills might be an array on the client; ensure it's a comma-separated string for the API
                const skillsValue = Array.isArray(updatedResume.skills) ? updatedResume.skills.join(',') : (updatedResume.skills || '');
                const categoryValue = Array.isArray(updatedResume.category) ? updatedResume.category.join(',') : (updatedResume.category || '');
                const transportValue = Array.isArray(updatedResume.transport) ? updatedResume.transport.join(',') : (updatedResume.transport || '');
                const industryValue = Array.isArray(updatedResume.industry) ? updatedResume.industry.join(',') : (updatedResume.industry || '');
                updateFormData.append('skills', skillsValue);
                updateFormData.append('category', categoryValue);
                updateFormData.append('transport', transportValue);
                updateFormData.append('industry', industryValue);
    const token = localStorage.getItem('authToken'); // Retrieve the token from local storage
    const response = await axios.put(
      `${API_PATHS.resumes}/${updatedResume._id}`,
      updateFormData,
      {
        headers: {
          Authorization: `Bearer ${token}`, // Add the Authorization header
          'Content-Type': 'multipart/form-data',
        },
      }
    );
    flashMessage("Resume updated successfully.", { type: "success" });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response && error.response.status === 400) {
      console.error("update resume failed with status 400:", error.response.data);
      flashMessage(`Update resume failed: ${error.response.data.error}`, { type: "error" });
    } else {
      console.error("Error updating resume:", error);
      flashMessage("Update resume failed. Please try again.", { type: "error" });
    }
    console.error(`Error updating resume with id ${updatedResume.id}:`, error);
    throw error;
  }
}

export async function createResumeAPI(formData) {
  try {
    const token = localStorage.getItem('authToken');
    const response = await axios.post(API_PATHS.resumes, formData, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'multipart/form-data',
      },
    });
    flashMessage("Resume created successfully.", { type: "success" });
    return response.data;
  } catch (error) {
    
    if (axios.isAxiosError(error) && error.response && error.response.status === 400) {
      console.error("create resume failed with status 400:", error.response.data);
      flashMessage(`Create resume failed: ${error.response.data.error}`, { type: "error" });
    } else {
      console.error("Error creating resume:", error);
      flashMessage("Create resume failed. Please try again.", { type: "error" });
    }
    throw error;
  }
}

export async function isFavorite(updatedResume) {
  try {
    const token = localStorage.getItem('authToken'); // Retrieve the token from local storage
    const response = await axios.patch(
      API_PATHS.isFavorite(updatedResume._id),
      { isFavorite: updatedResume.isFavorite },
      {
        headers: {
          Authorization: `Bearer ${token}`, // Add the Authorization header
          'Content-Type': 'application/json',
        },
      }
    );
    flashMessage("isFavorite updated successfully.", { type: "success" });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response && error.response.status === 400) {
      console.error("update isFavorite failed with status 400:", error.response.data);
      flashMessage(`Update isFavorite failed: ${error.response.data.error}`, { type: "error" });
    } else {
      console.error("Error updating isFavorite:", error);
      flashMessage("Update isFavorite failed. Please try again.", { type: "error" });
    }
    console.error(`Error updating isFavorite with id ${updatedResume.id}:`, error);
    throw error;
  }
}